export const FrameResource = {
  "ExpressionTitle": "高級表達式",
  "ExpressionSave": "保存",
  "ExpressionCancel": "取消",
  "CheckFront": "校驗",
  "ResetFront": "重置",
  "AiAssistant": "智能助手",
  "HelpFront": "說明",
  "ImportFront": "導入",
  "Advanced": "高級",
  "String": "字符",
  "Estimate": "判斷",
  "DateTime": "時間",
  "Translate": "轉換",
  "Analytical": "數據",
  "Math": "數學",
  "Extend": "擴展",
  "FunctionSemanticName": "語義化名稱",
  "FunctionName": "函數名稱",
  "FunctionParameter": "參數",
  "Variable": "變量",
  "VariableSessionValue": "會話",
  "VariableContextParameter": "上下文",
  "VariableName": "名稱",
  "VariableSemanticNameValue": "語義化名稱",
  "Entity": "數據模型",
  "EntityAllColumn": "編號/名稱",
  "EntityCode": "編號",
  "EntityName": "名稱",
  "EntityType": "類型",
  "EntityPropList": "屬性列表",
  "Help": "幫助",
  "HelpCode": "編號",
  "HelpName": "名稱",
  "HelpDesc": "請選擇",
  "HelpDescription": "請選擇",
  "SaveButton": "保存",
  "CancelButton": "取消",
  "FunctionDescription": "函數說明：",
  "VarDescription": "變量說明：",
  "CurrentProp": "當前屬性：",
  "CurrentChosedProp": "當前選擇屬性：",
  "PopverTitleDesc": "使用說明",
  "HelpButtonDesc": {
    $implicit: {
      'syntax': '語法支持',
      'desc': '支持JavaScript語法,不支持"and、or、in、not in"等寫法,可用&&代替and，||代替or',
      'buttonDesc': '按鈕',
      'checkButtonDesc': '校驗：語法校驗',
      'resetButtonDesc': '重置：清空編輯框',
      'functionDesc': '函數',
      'clickFunctionDesc': '單擊：展示函數說明，參數，返回類型和示例',
      'dbclickFunctionDesc': '雙擊：將函數插入到編輯框中',
      'entityDesc': '數據',
      'insertByStructureDesc': '按結構：將形如"saleOrder.code"的鍊式結構插值到編輯框中',
      'insertByPropertyDesc': '按屬性：將"code"屬性插值到編輯框中',
      'otherDesc': '其他',
      'areaChangeDesc': '區域伸縮：函數區域和數據區域可以改變大小',
      'chainedStrucDesc': '鍊式結構：形如"saleOrder.code"以.分隔的結構為鍊式結構'
    }
  },
  "InsertType": "插值方式",
  "InsertByStruct": "結構",
  "InsertByAttr": "屬性",
  "GetEnum": "枚舉取值",
  "EnumJudge": "枚舉判斷",
  "NewDataTypeString": "字符串",
  "NewDataTypeByte": "字節",
  "NewDataTypeBoolean": "布爾",
  "NewDataTypeDate": "日期",
  "NewDataTypeDateTime": "日期時間",
  "NewDataTypeDecimal": "十進制數",
  "NewDataTypeInteger": "整數",
  "NewDataTypeEnum": "枚舉",
  "EntityType_Main": "主錶",
  "EntityType_ChildTable": "子錶",
  "EntityType_Other": "實體",
  "EntitySet": "子錶",
  "EntityEnum": "枚舉",
  "EntityEnum_Int": "整數",
  "EntityEnum_String": "字符串"
}